import { HTTP } from 'src/lib/axios'
import { Iconference } from '../types/twilio'

export const isElectron = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.indexOf(' electron/') !== -1
}

export const sortListByDate = (
  list: Array<any>,
  datePropertyName: string,
  desc = false
) => {
  const clone = [...list]
  return clone.sort((a: any, b: any) => {
    if (!desc) {
      return (
        Number(new Date(a[datePropertyName])) -
        Number(new Date(b[datePropertyName]))
      )
    }
    return (
      Number(new Date(b[datePropertyName])) -
      Number(new Date(a[datePropertyName]))
    )
  })
}

export const sortListByNumber = (
  list: Array<any>,
  propertyName: string,
  desc = false
) => {
  const clone = [...list]
  return clone.sort((a: any, b: any) => {
    if (!desc) {
      return a[propertyName] - b[propertyName]
    }
    return b[propertyName] - a[propertyName]
  })
}

export const sortListByString = (
  list: Array<any>,
  propertyName: string,
  desc = false
) => {
  const clone = [...list]
  return clone.sort((a: any, b: any) => {
    if (desc) {
      return a[propertyName].localeCompare(b[propertyName])
    }
    return b[propertyName].localeCompare(a[propertyName])
  })
}

export const formatNumber = (
  phoneNumber: string,
  addIntlCode = false
): string => {
  const unformattedNum = phoneNumber
  const cleaned = ('' + unformattedNum).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = match[1] ? '+1 ' : ''
    return [
      addIntlCode ? intlCode : '',
      '(',
      match[2],
      ') ',
      match[3],
      '-',
      match[4]
    ].join('')
  }
  return phoneNumber
}

export const checkValidNumber = (string: string): boolean => {
  if (!string.length || string.length >= 11 || !string.match(/^-?\d+$/))
    return false
  return true
}

export const enforceCharacterLimit = (
  string: string,
  limit: number
): string => {
  return string.length > limit ? string.substring(0, limit) : string
}

export const formattedDuration = (seconds: number) => {
  if (!seconds) {
    return ''
  }
  try {
    const date = new Date(0)
    date.setSeconds(seconds)
    const timeString = date.toISOString().substr(11, 8)
    if (timeString.substr(0, 2) === '00') return timeString.substr(3)
    return timeString
  } catch (err) {
    return seconds
  }
}

export const getCallTime = (call: Iconference) => {
  if (call.incoming) return 'Incoming'
  if (!call.dateCreated) return ''
  if (call.conf_status !== 'completed') {
    const elapsed = Math.floor((Date.now() - call.dateCreated) / 1000)
    return formattedDuration(elapsed)
  }
  let last = 0
  if (typeof call.lastUpdate === 'string' && call.lastUpdate.length === 13) {
    last = parseInt(call.lastUpdate, 10)
  }
  const elapsed = Math.floor((last - call.dateCreated) / 1000)
  return formattedDuration(elapsed)
}

export const isElementInViewport = (el: any) => {
  const rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export const getContactById = (id: string, contacts: any) => {
  const contact = contacts.find((c) => c.contactId === id)
  if (contact) {
    return contact
  }
  return null
}

export const userIsParticipant = (
  australisId: string,
  participantLabel: string
) => {
  const formattedId = australisId.replaceAll('-', '')

  return (
    participantLabel === `${formattedId}_web` ||
    participantLabel === `client:${formattedId}_web`
  )
}

export const getAnyMyDeviceParticipantSid = (
  liveParticipants: any,
  australisId: string,
  otherParticipants: any
) => {
  const id = australisId.replaceAll('-', '')

  const found = Object.keys(liveParticipants).find((p) => {
    if (p.includes(id)) return true

    const callSID = liveParticipants[p]
    if (otherParticipants[callSID].australisId === australisId) return true

    return false
  })

  if (found) {
    return liveParticipants[found]
  }

  return ''
}

export const getMyDeviceName = (australisId) => {
  return `${australisId.replaceAll('-', '')}_web`
}

export const getUserById = (id: string, users: any) => {
  const user = Object.keys(users).find((u) => userIsParticipant(id, u))
  if (user) {
    return users[user]
  }
  return null
}

export function formatMinutes(minutes: number) {
  return minutes < 10 ? `0${minutes}` : `${minutes}`
}

export function formatSeconds(seconds: number) {
  return seconds < 10 ? `0${seconds}` : `${seconds}`
}

export const sendAlert = async (token: string, text: string) => {
  try {
    const response = await HTTP.post(
      '/metrics/internal/alerts',
      { text },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return response
  } catch (e) {
    console.error(e)

    return e
  }
}

export const between = (value: number, target: number, range: number) => {
  return value < target + range && value > target - range
}
